import { createSelector } from "@reduxjs/toolkit";

import { discoveryPanelsSelector } from "./discoveryPanels.selector";

export const filterSelector = createSelector(
  discoveryPanelsSelector,
  state => state.filter,
);